import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const RadioBt = ({
    checked = false,
    onChange,
    value,
    label,
    disabled = false,
    sx = {},
    ...props
}) => {
    const theme = useTheme();
    const radioBtStyles = {
        width: '22px',
        height: '22px',
        borderRadius: '39px',
        backgroundColor: theme.palette.figma.white[10],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: disabled
                ? theme.palette.figma.white[10]
                : theme.palette.figma.white[20],
        },
        ...sx,
    };

    const innerDotStyles = {
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        backgroundColor: checked ? theme.palette.figma.buttonOrange : 'transparent',
        transition: 'all 0.2s ease-in-out',
    };

    const borderStyles = {
        position: 'absolute',
        inset: 0,
        border: `1px solid ${theme.palette.figma.white[30]}`,
        borderRadius: '39px',
        pointerEvents: 'none',
    };

    const handleClick = () => {
        if (!disabled && onChange) {
            onChange({ target: { value } });
        }
    };

    if (label) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    padding: '9px 20px',
                    borderRadius: '13px',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s ease-in-out',
                    ...sx,
                }}
                onClick={handleClick}
                {...props}
            >
                <Box sx={radioBtStyles}>
                    <Box sx={borderStyles} />
                    <Box sx={innerDotStyles} />
                </Box>
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: checked ? 600 : 400,
                        color: disabled
                            ? theme.palette.figma.white[30]
                            : checked
                                ? theme.palette.figma.white[100]
                                : theme.palette.figma.white[80],
                        letterSpacing: '-0.42px',
                    }}
                >
                    {label}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={radioBtStyles}
            onClick={handleClick}
            {...props}
        >
            <Box sx={borderStyles} />
            <Box sx={innerDotStyles} />
        </Box>
    );
};

const RadioGroup = ({
    value,
    onChange,
    children,
    name,
    sx = {},
    ...props
}) => {
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '0px',
                borderRadius: '15px',
                padding: '2px',
                ...sx,
            }}
            {...props}
        >
            {React.Children.map(children, (child, index) => {
                if (React.isValidElement(child)) {
                    const childValue = child.props.value;
                    const isSelected = value === childValue;

                    return React.cloneElement(child, {
                        checked: isSelected,
                        onChange: handleChange,
                        key: index,

                    });
                }
                return child;
            })}
        </Box>
    );
};

export default RadioBt;
export { RadioGroup };
